import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoahmednagartaxi() {



  const cardData = {
"keyword": "Pune to Ahmednagar Taxi",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Ahmednagar Taxi service for travelers looking for safe, affordable, and convenient intercity transportation. Whether you are traveling for business, family visits, religious trips, or daily commuting, our taxi service ensures a smooth and stress-free journey. With experienced drivers, clean air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Ahmednagar. Our fleet includes sedans, SUVs, and premium cars suitable for solo travelers, families, and corporate clients. With flexible one-way and round-trip options, doorstep pickup, and 24/7 customer support, Shivai Travels ensures a comfortable and timely travel experience.",

"topPlaces": [
  {
    "title": "Meherabad",
    "description":
      "Meherabad is a peaceful spiritual site near Ahmednagar associated with Meher Baba. Travelers using Pune to Ahmednagar taxi service often visit this serene destination for meditation and spiritual exploration."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is one of India’s most famous pilgrimage destinations dedicated to Sai Baba. Many travelers from Pune to Ahmednagar route extend their journey to Shirdi for darshan and blessings."
  },
  {
    "title": "Ahmednagar Fort",
    "description":
      "Ahmednagar Fort is a historic monument known for its Mughal architecture and military significance. Pune to Ahmednagar taxi service provides easy access for history enthusiasts."
  },
  {
    "title": "Cavalry Tank Museum",
    "description":
      "Cavalry Tank Museum in Ahmednagar showcases India’s armored military vehicles and history. Travelers from Pune often visit this unique museum during their trip."
  },
  {
    "title": "Bhandardara",
    "description":
      "Bhandardara is a scenic hill station near Ahmednagar known for waterfalls, lakes, and greenery. Taxi travelers from Pune enjoy visiting this peaceful nature destination."
  },
  {
    "title": "Renuka Mata Temple",
    "description":
      "Renuka Mata Temple is a popular religious site near Ahmednagar visited by devotees for spiritual blessings. Pune to Ahmednagar taxi service offers convenient access to this temple."
  },
  {
    "title": "Ralegan Siddhi",
    "description":
      "Ralegan Siddhi is a model village known for social development and environmental conservation efforts. Travelers often visit this inspirational destination from Pune."
  },
  {
    "title": "Cine Prism Ahmednagar",
    "description":
      "Cine Prism is a modern entertainment and cinema complex in Ahmednagar. Taxi service from Pune provides easy access for leisure and entertainment trips."
  },
  {
    "title": "Mula Dam",
    "description":
      "Mula Dam is a scenic water reservoir near Ahmednagar surrounded by natural beauty. Pune to Ahmednagar taxi travelers often stop here for relaxation and photography."
  },
  {
    "title": "Chand Bibi Mahal",
    "description":
      "Chand Bibi Mahal is a historical site in Ahmednagar reflecting ancient architecture and heritage. Taxi service from Pune makes it easy to explore this landmark."
  }
],



services: [
  {
    name: "Pune to Ahmednagar Cab",
    description: "Pune to Ahmednagar cab service provides reliable transportation between Pune and Ahmednagar with comfortable vehicles and experienced drivers. Vehicles are suitable for highway travel ensuring smooth and safe journeys for families, tourists, and business travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ahmednagar. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Ahmednagar Taxi",
    description: "Pune to Ahmednagar taxi service offers dependable transportation for passengers traveling between Pune and Ahmednagar with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for business trips, tourism, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Ahmednagar. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab from Pune to Ahmednagar",
    description: "Cab from Pune to Ahmednagar service provides comfortable intercity transportation for passengers traveling for business, tourism, and family visits. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune and Ahmednagar. Ideal for one-way and round-trip travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Ahmednagar",
    description: "Taxi from Pune to Ahmednagar service offers reliable transportation with comfortable vehicles and professional drivers for long-distance travel between Pune and Ahmednagar. Vehicles provide smooth highway travel suitable for tourism, business meetings, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Ahmednagar. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Ahmednagar Cab Service",
    description: "Pune to Ahmednagar cab service provides dependable transportation solutions for passengers traveling between Pune and Ahmednagar with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for highway travel ensuring safe and smooth journeys for individuals, families, and corporate travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ahmednagar. Ideal for business travel, tourism, and family trips. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Ahmednagar Taxi Fare",
    description: "Pune to Ahmednagar taxi fare service provides transparent pricing information for passengers planning intercity travel between Pune and Ahmednagar. Travelers can estimate transportation costs based on vehicle type, travel distance, and trip requirements. Comfortable vehicles ensure smooth highway travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ahmednagar. Flexible booking options allow convenient fare estimation and taxi reservations."
  },
  {
    name: "Pune to Ahmednagar One Way Cab",
    description: "Pune to Ahmednagar one way cab service provides economical transportation for passengers traveling from Pune to Ahmednagar without return travel requirements. Comfortable vehicles ensure smooth highway travel suitable for business trips, tourism, and family visits. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Ahmednagar including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Ahmednagar Round Trip Taxi",
    description: "Pune to Ahmednagar round trip taxi service offers convenient return transportation for passengers planning travel between Pune and Ahmednagar. Comfortable vehicles provide smooth highway journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ahmednagar. Ideal for business travel, tourism, and family trips. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Pune to Ahmednagar Cab Booking",
    description: "Pune to Ahmednagar cab booking service allows passengers to reserve comfortable intercity transportation between Pune and Ahmednagar. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ahmednagar. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Cheap Pune to Ahmednagar Cab",
    description: "Cheap Pune to Ahmednagar cab service provides affordable transportation between Pune and Ahmednagar with comfortable vehicles and economical pricing. Vehicles ensure reliable highway travel suitable for tourism, business travel, and family journeys. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Ahmednagar. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Ahmednagar Taxi",
    description: "Best Pune to Ahmednagar taxi service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth intercity travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for business travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ahmednagar. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Ahmednagar Cab",
    description: "Sedan Pune to Ahmednagar cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Ahmednagar. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for intercity journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Ahmednagar. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Ahmednagar Taxi",
    description: "SUV Pune to Ahmednagar taxi service provides spacious transportation for families and groups traveling between Pune and Ahmednagar. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for long-distance journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Ahmednagar. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Ahmednagar Cab",
    description: "Innova Pune to Ahmednagar cab service provides premium SUV transportation for passengers seeking comfortable and reliable intercity travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for business travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Ahmednagar. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Fast Route Taxi Pune Ahmednagar",
    description: "Fast route taxi Pune Ahmednagar service provides quick and reliable highway transportation between Pune and Ahmednagar with comfortable vehicles and experienced drivers. Vehicles ensure smooth travel performance suitable for business trips, tourism, and family travel requirements. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Ahmednagar. Flexible booking options allow convenient fast-route taxi reservations."
  },
  {
    name: "Pune to Ahilyanagar Cab Service",
    description: "Pune to Ahilyanagar cab service provides dependable transportation between Pune and Ahilyanagar with comfortable vehicles and professional chauffeurs. Vehicles offer smooth highway travel suitable for business journeys, tourism, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ahilyanagar. Flexible booking options allow convenient one-way and round-trip cab reservations."
  }
],

tableData: [
  ["Pune to Ahmednagar Cab", "Pune to Ahmednagar Taxi"],
  ["Cab from Pune to Ahmednagar", "Taxi from Pune to Ahmednagar"],
  ["Pune to Ahmednagar Cab Service", "Pune to Ahmednagar Taxi Fare"],
  ["Pune to Ahmednagar One Way Cab", "Pune to Ahmednagar Round Trip Taxi"],
  ["Pune to Ahmednagar Cab Booking", "Cheap Pune to Ahmednagar Cab"],
  ["Best Pune to Ahmednagar Taxi", "Sedan Pune to Ahmednagar Cab"],
  ["SUV Pune to Ahmednagar Taxi", "Innova Pune to Ahmednagar Cab"],
  ["Fast Route Taxi Pune Ahmednagar", "Pune to Ahilyanagar Cab Service"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Ahmednagar Taxi Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Ahmednagar taxi service with professional drivers, comfortable vehicles, and punctual pickup for safe and smooth intercity travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Ahmednagar Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Ahmednagar taxi pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Ahmednagar Taxi Availability",
        WhyChoosedescription: "Our Pune to Ahmednagar taxi service operates 24 hours a day for business travel, family trips, emergency transportation, airport transfers, and outstation journeys."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Taxis",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Taxi Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Ahmednagar taxi service, round-trip bookings, business travel, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Taxi Vehicle Options",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, corporate travelers, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Highway Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Ahmednagar highway routes and ensure safe driving, smooth travel, and timely arrival for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Ahmednagar taxi service?", answer: "Pune to Ahmednagar taxi service provides comfortable taxi transportation between Pune and Ahmednagar for business travel, family trips, and outstation journeys." },
    { question: "Is Pune to Ahmednagar taxi service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Ahmednagar taxi service." },
    { question: "Which vehicles are available for Pune to Ahmednagar travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way taxi from Pune to Ahmednagar?", answer: "Yes, customers can book one-way as well as round-trip Pune to Ahmednagar taxi services." },
    { question: "Do you provide airport pickup and drop services?", answer: "Yes, Shivai Travels provides airport transfer services along with outstation taxi bookings." },
    { question: "Are all Pune to Ahmednagar taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Pune to Ahmednagar taxi service online?", answer: "Yes, customers can easily book Pune to Ahmednagar taxi service online or through phone booking." },
    { question: "Do you provide taxis for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Pune to Ahmednagar taxi fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Ahmednagar taxi service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and festive seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Vivek Shinde",
      feedback:
        "Booked Pune to Ahmednagar taxi service with Shivai Travels. Comfortable car, professional driver, and smooth highway journey.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Rupal Deshmukh",
      feedback:
        "Excellent Pune to Ahmednagar taxi service. Affordable pricing, clean vehicle, and very reliable travel experience.",
      rating: 5
    }
  ];






































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ahmednagar Taxi Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-ahmednagar-taxi.jpg",
  "description": "Book Pune to Ahmednagar taxi service for safe and comfortable intercity travel. Shivai Travels offers affordable one-way and round-trip cab booking with sedan, SUV, Innova, and luxury cab options available 24x7 for fast route travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹11/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-ahmednagar-taxi"
  }
};



  return (
    <div>

<Helmet>
  <title>Pune to Ahmednagar Taxi | Affordable Intercity Cab Service | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Ahmednagar taxi service for one-way and round trip travel. Affordable cab options including sedan, SUV, Innova, and luxury taxis available 24x7 for fast and safe intercity journeys."
  />

  <meta
    name="keywords"
    content="pune to ahmednagar cab, pune to ahmednagar taxi, cab from pune to ahmednagar, taxi from pune to ahmednagar, pune to ahmednagar cab service, pune to ahmednagar taxi fare, pune to ahmednagar one way cab, pune to ahmednagar round trip taxi, pune to ahmednagar cab booking, cheap pune to ahmednagar cab, best pune to ahmednagar taxi, sedan pune to ahmednagar cab, suv pune to ahmednagar taxi, innova pune to ahmednagar cab, fast route taxi pune ahmednagar, Pune to Ahmednagar Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/19.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoahmednagartaxi;